import React from "react";

// components
import DocumentsControl from "./documentsControl/DocumentsControl";
import {  useSelector, useDispatch } from "react-redux";
const DocumentsControls = ({foldersData}) => {
  
 
  return foldersData !== null &&  foldersData.map((folder) => (
    <DocumentsControl key={folder.folder_id} id={folder.folder_id} name={folder.name} />
  ));
  
  
};

export default DocumentsControls;
